export default {
  modal: {
    placeholders: {
      dateFrom: "Access from",
      dateTo: "Access to",
    },
  },
  list: {
    headers: {
      id: "ID",
      name: "First and last name",
      email: "Email address",
      date: "Access granted date",
      dateArchitect: "B2B Access [Architect]",
      dateSubscription: "B2C Access",
      role: "Role",
      company: "Company",
      programs: "Programs",
      groups: "Groups",
      onboarding: "Onboarding",
      logInAs: "Log in as",
    },
    actions: {
      joinToProgram: "Join to program",
      leaveFromProgram: "Leave from program",
    },
    labels: {
      role: "Role",
      company: "Company",
      hasAccess: "Access",
      date: "Access date",
      path: "Path",
      onboarding: "Onboarding",
      onboardingActive: "Onboarding active",
      onboardingInactive: "Onboarding inactive",
      programViaCompany: "Access through the company - cannot be removed per user",
    },
  },
  form: {
    messages: {
      info: "You are adding users to the company",
    },
    tabs: {
      addWithEmail: "Add with email addresses",
      addFormFile: "Add from file",
      overwriteFormFile: "Overwrite from file",
      deleteAccesses: "Remove accesses",
      automatic: "Automatically",
    },
    labels: {
      password: "Password",
      passwordHelp: "Leave this field empty if you don't want to change",
      canPreview: "Has preview",
      role: "Role",
      enterEmailAddresses: "Email address",
      prefix: "Prefix",
      randomPass: "Random passwords",
      ownPass: "Own password",
      name: "First name",
      surname: "Last name",
      email: "Email address",
      freeAccess: "Free access",
      uploadDrop: "or drag and drop here",
      allowFormat: "Allowed CSV format",
      addToCompany: "Add to company",
      optionalOption: "(optional)",
      addWithPath: "Add with path",
      path: "Path",
      accountNumber: "Number of accounts",
      addNameAndSurname: "Add first and last name",
      option: "optional",
      newUI: "New UI",
    },
    hintText: {
      underTextAreaAuto:
        'E.g. providing "user", will result in generating accounts with address',
      lifetimeAccess: "If no date is selected, it means lifetime access.",
      accountsQuantity: "Specify the number of accounts to be generated.",
    },
    placeholders: {
      noPath: "No path",
      noCompany: "No company",
      name: "John",
      surname: "Doe",
      uploadClick: "Click to select file",
      dateFrom: "Select from when",
      dateTo: "Select until when",
    },
    buttons: {
      addUsers: "Add users",
      updateUsers: "Update users",
      addAnotherUser: "Add another user",
    },
  },
  buttons: {
    addUsers: "Add users",
    addAnotherUser: "Add another user",
  },
};
